import { Loading } from 'element-ui'

let loadingInstance = null
let count = 0

/**
 * loading画面を表示する.
 * @param type 表示タイプ. 'dark' or 'light'
 */
function show ({ type = 'dark' } = {}) {
  let background = 'rgba(0, 0, 0, 0.3)'
  switch (type) {
    case 'dark':
    default:
      break
    case 'light':
      background = 'rgba(0, 0, 0, 0)'
      break
  }
  loadingInstance = Loading.service({
    lock: false,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background
  })
  count++
};

function close () {
  count = count === 0 ? 0 : count - 1
  if (loadingInstance && count === 0) {
    loadingInstance.close()
    loadingInstance = null
  }
};

export default {
  install: function (Vue, opt = {}) {
    Vue.prototype.$loadingService = {
      show,
      close
    }
  }
}
